var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"left":"","max-width":"500"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g({attrs:{"icon":"","small":""}},on),[_c('v-icon',_vm._g(_vm._b({attrs:{"small":""}},'v-icon',attrs,false),on),[_vm._v("fas fa-question-circle")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.helpText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }